import { render, staticRenderFns } from "./ExibirOrgao.vue?vue&type=template&id=2bdd99ce&scoped=true&"
import script from "./ExibirOrgao.vue?vue&type=script&lang=js&"
export * from "./ExibirOrgao.vue?vue&type=script&lang=js&"
import style0 from "./ExibirOrgao.vue?vue&type=style&index=0&id=2bdd99ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd99ce",
  null
  
)

export default component.exports